import React from "react";
import logoAGHUX from "../../../../assets/logo/logoAghux.svg";
import "./Section.css";

export function Section() {
  return (
    <div className="contentTextLanding">
      <img alt="logo aghux" className="logoAghu" src={logoAGHUX} />
      <h3 className="description">
        O <strong>HU Digital</strong> é uma plataforma da Rede HU Brasil para
        acesso aos dados dos sumários de alta, procedimentos ambulatoriais e
        exames registrados no Aplicativo de Gestão para Hospitais Universitários
        (AGHU).
      </h3>
    </div>
  );
}
